import {useLocation} from "react-router-dom";
import {useEffect} from "react";

/**
 * A component that scrolls the window to the top on every route change.
 * It listens for changes in the `pathname` and triggers a scroll to the top of the page.
 * This ensures that when a user navigates to a new page, they start from the top,
 * providing a consistent user experience.
 *
 * Note: This component intentionally ignores the `hash` part of the URL to allow
 * the browser's default anchor link behavior to function correctly.
 */
export const ScrollToTop = () => {
    const {pathname} = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]); // Only re-run the effect if the pathname changes
    return null;
}